import { render, staticRenderFns } from "./transportsItems.vue?vue&type=template&id=6fb40d78&scoped=true&"
import script from "./transportsItems.vue?vue&type=script&lang=js&"
export * from "./transportsItems.vue?vue&type=script&lang=js&"
import style0 from "./transportsItems.vue?vue&type=style&index=0&id=6fb40d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb40d78",
  null
  
)

export default component.exports